import { AnswerType } from "@/entities/questionaire/answers/AnswerType";
import { Answer } from "@/entities/questionaire/answers/Answer";
import { BooleanAnswer } from "@/entities/questionaire/answers/BooleanAnswer";
import { IntegerAnswer } from "@/entities/questionaire/answers/IntegerAnswer";
import { SingleItemAnswer } from "@/entities/questionaire/answers/SingleItemAnswer";
import { MultipleItemsAnswer } from "@/entities/questionaire/answers/MultipleItemsAnswer";
import constants from "@/entities/constants";

export class Property {
  id: number;
  isPrimary: boolean;
  question: string;
  failed: boolean = false;
  answer: Answer;
  hint: string;
  selectedAnswer: Answer;
  label: string;
  conditionQuestion: string;
  answerQuestions?: string[];
  questionConditionId?: number;
  groupName?: string;
  isHidden?: boolean;
  answerConditionCount?: number;
  answerQuestionsText?: string[];
  keyDecision:string;
  questionSubType:string;
  autoAnswer:boolean = false;
  referenceQuestionId?:number;
  minValue?:number;
  maxValue?:number;
  minInclusive: boolean = false;
  maxInclusive: boolean = false;
  get type(): AnswerType {
    return this.answer.getType();
  }

  constructor(
    id: number,
    isPrimary: boolean,
    question: string,
    answer: Answer,
    hint: string,
    selectedAnswer: Answer,
    label: string,
    conditionQuestion: string,
    answerQuestions?: string[],
    questionConditionId?: number,
    groupName?: string,
    isHidden?: boolean,
    answerConditionCount?: number,
    answerQuestionsText?: string[],
    keyDecision: string = "",
    questionSubType:string = "",
      minValue?:number,
    maxValue?:number,
    minInclusive: boolean = false,
    maxInclusive: boolean = false,
      autoAnswer: boolean = false,
    referenceQuestionId?: number ,
  ) {
    this.id = id;
    this.isPrimary = isPrimary;
    this.question = question;
    this.answer = answer;
    this.hint = hint;
    this.selectedAnswer = selectedAnswer;
    this.label = label;
    this.conditionQuestion = conditionQuestion;
    this.answerQuestions = answerQuestions;
    this.questionConditionId = questionConditionId;
    this.groupName = groupName;
    this.isHidden = isHidden;
    this.answerConditionCount = answerConditionCount;
    this.answerQuestionsText = answerQuestionsText;
    this.keyDecision = keyDecision;
    this.questionSubType = questionSubType;
    this.minValue = minValue;
    this.maxValue = maxValue;
    this.minInclusive = minInclusive;
    this.maxInclusive = maxInclusive;
     this.autoAnswer = autoAnswer;
    this.referenceQuestionId = referenceQuestionId;
  }

  static createProperty(obj: any): Property {
    let answerFromObj: Answer;

    switch (obj.answerType) {
      case constants.answerTypes.BooleanAnswer.type:
        answerFromObj = new BooleanAnswer(
          obj.id,
          obj.answer,
          obj.text,
          obj.expectedAnswer
        );
        break;

      case constants.answerTypes.IntegerAnswer.type:
        answerFromObj = new IntegerAnswer(obj.id);
        break;

      case constants.answerTypes.SingleItemAnswer.type:
        answerFromObj = SingleItemAnswer.createAnswer(obj);
        break;

      case constants.answerTypes.MultipleItemsAnswer.type:
        answerFromObj = MultipleItemsAnswer.createAnswer(obj);
        break;

      default:
        throw new Error("Unknown answer type!");
    }

    return new Property(
      obj.id, 
      obj.isPrimary, 
      obj.question, 
      answerFromObj, 
      obj.hint, 
      obj.selectedAnswer, 
      obj.label,
      obj.conditionQuestion,
      obj?.answerQuestions,
      obj?.questionConditionId,
      obj?.groupName,
      obj?.isHidden,
      obj?.answerConditionCount,
      obj?.answerQuestionsText,
      obj?.keyDecision || "",
       obj?.questionSubType || "",
       obj?.minValue,
       obj?.maxValue,
      obj?.minInclusive || false,
      obj?.maxInclusive || false,
      obj?.autoAnswer || false,
      obj?.referenceQuestionId
    );
  }

  toOpinionModel(): any {
    const result: any = {
      id: this.id,
      question: this.question,
      answerType: this.answer.getType()
    };

    switch (this.answer.getType()) {
      case AnswerType.Boolean:
        result.expectedAnswer = (this.answer as BooleanAnswer).expectedAnswer;
        break;

      case AnswerType.Integer:
        break;

      case AnswerType.SingleItem:
        result.answerVariants = (this.answer as SingleItemAnswer).variants;
        break;

      case AnswerType.MultipleItems:
        result.answerVariants = (this.answer as MultipleItemsAnswer).variants;
        break;

      default:
        throw new Error("Unknown answer type!");
    }

    return result;
  }
}
